export default __webpack_public_path__ + "static/media/home_page_framed.18f1bb25.png";